/* eslint-disable */
import {DateTime} from 'luxon';

// Based on rules in story:
// https://mathletics.atlassian.net/browse/FRAME-4783

export type EndDateOptions = {
    now?: DateTime
    endDate?: DateTime
    startDate: DateTime
}

type ErrorCases = {
    earliestDate: EndDateErrorCase
    endDay: EndDateErrorCase
}

export const EndDateErrorTypes: ErrorCases = {
    endDay: {
        errorType: 'endDay',
        message: 'The ending day of an academic must be a Sunday'
    },
    earliestDate: {
        errorType: 'earliestDate',
        message: 'The earliest date that can be set is \'tomorrow\''
    }
};

export const VisibleEndDateErrorTypes: Omit<ErrorCases, 'earliestDate'> = {
    endDay: EndDateErrorTypes.endDay
};

export type EndDateErrorCase = {
    message: string
    errorType: keyof ErrorCases
}

export type ValidateEndDateResult = {
    endDate: DateTime
    errors: Array<EndDateErrorCase>
}

export const validateEndDate = (options: EndDateOptions): ValidateEndDateResult => {
    const errors: Array<EndDateErrorCase> = [];
    const startDate = options.startDate;
    const endDate = options.endDate ? options.endDate : getNextEndDate(startDate);

    const currentEndDay = endDate.toFormat('EEEE');
    if (currentEndDay !== 'Sunday') {
        errors.push(EndDateErrorTypes.endDay);
    }

    return {endDate, errors};
};

export const getNextEndDate = (startDate: DateTime): DateTime => {
    const tomorrow = DateTime.now().plus({day: 1});
    const duration = tomorrow.diff(startDate, ['days']);

    if (Math.ceil(duration.days) >= 365) {
        return tomorrow;
    }

    return startDate.plus({day: 365});
};
